import React from 'react';
import PropTypes from 'prop-types';

// Components
import CustomerVehicle from 'components/atoms/CustomerVehicle';

const ns = 'customer-vehicle-list';

const CustomerVehicleList = ({ carData, goTo, showMileage }) => {
  return (
    <div className={ns} id="customer_vehicle_list">
      {carData.map(car => {
        return (
          <CustomerVehicle
            carData={car}
            key={car.vehicleId}
            goTo={goTo}
            showMileage={showMileage}
          />
        );
      })}
    </div>
  );
};

CustomerVehicleList.propTypes = {
  carData: PropTypes.array.isRequired,
  goTo: PropTypes.func.isRequired,
  showMileage: PropTypes.bool
};

export default CustomerVehicleList;



// WEBPACK FOOTER //
// ./src/components/molecules/CustomerVehicleList/CustomerVehicleList.js